import { red } from '@material-ui/core/colors';
import { darken, lighten, rgbToHex } from '@material-ui/core';

export interface ColorPalette {
  primaryScale: string[];
  secondaryScale: string[];
  tertiaryScale: string[];
  performanceScale: string[];
  textColor: string[];
}

export const DefaultPalette: ColorPalette = {
  primaryScale: ['#466263', '#69938C', '#8DC3AE'],
  secondaryScale: [
    rgbToHex(lighten('#b8873c', 0.3)).toUpperCase(),
    rgbToHex(lighten('#edb769', 0.1)).toUpperCase(),
    rgbToHex(darken('#ffe998', 0.05)).toUpperCase(),
  ],
  tertiaryScale: ['#0b1927', '#323f4f', '#5c6a7b'],
  performanceScale: [
    '#8DC3AE',
    '#69938C',
    '#466263',
    rgbToHex(darken('#ffe998', 0.15)).toUpperCase(),
    rgbToHex(lighten('#edb769', 0.05)).toUpperCase(),
    red[200],
  ],
  textColor: ['#FFFFFF'],
};

export const parsePalette = (paletteJson?: string): ColorPalette => {
  const parsedPalette: ColorPalette = !!paletteJson ? JSON.parse(paletteJson) : undefined;
  return {
    ...DefaultPalette,
    performanceScale: DefaultPalette.performanceScale.map(
      (color, index) => parsedPalette?.performanceScale?.[index] ?? color
    ),
    primaryScale: DefaultPalette.primaryScale.map(
      (color, index) => parsedPalette?.primaryScale?.[index] ?? color
    ),
    secondaryScale: DefaultPalette.secondaryScale.map(
      (color, index) => parsedPalette?.secondaryScale?.[index] ?? color
    ),
    tertiaryScale: DefaultPalette.tertiaryScale.map(
      (color, index) => parsedPalette?.tertiaryScale?.[index] ?? color
    ),
    textColor: DefaultPalette.textColor.map(
      (color, index) => parsedPalette?.textColor?.[index] ?? color
    ),
  };
};
